<template>
  <div class="wrapper">
    <div v-if="isLoading" class="isLoading">
      <div class="loading-box">
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
        <i class="cube"></i>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState({
        isLoading: state => state.base.isLoading
      })
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
  .wrapper {
    height: 100%;
  }

  .isLoading {
    height: 100%;
    background: #dedede;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .loading-box {
      height: 9em;
      left: 50%;
      margin: -7.5em;
      padding: 3em;
      position: absolute;
      top: 50%;
      width: 9em;
      transform: rotateX(45deg) rotateZ(45deg);
      transform-style: preserve-3d;
    }

    .cube {
      background-image: url(../static/img/logo_gray.jpg);
      background-repeat: no-repeat;
      background-color: #f2f2f2;
      float: left;
      height: 3em;
      width: 3em;
      position: relative;
      transform: translateZ(3em);
      transform-style: preserve-3d;
      transition: .25s;
      box-shadow: 13em 13em 1.5em rgba(0, 0, 0, .1);
      animation: loading 1s infinite;

      &:before, &:after {
        content: '';
        position: absolute;
        float: left;
        height: 3em;
        width: 3em;
      }

      &:after {
        background: #aaa;
        transform: rotateX(-90deg) translateY(3em);
        transform-origin: 100% 100%;
      }

      &:before {
        background: #bbb;
        transform: rotateY(90deg) translateX(3em);
        transform-origin: 100% 0;
      }

      &:nth-child(1) {
        animation-delay: 0.05s;
        background-position: 0 0;
      }

      &:nth-child(2) {
        background-position: -46.667px 0;
        animation-delay: 0.1s;
      }

      &:nth-child(3) {
        animation-delay: 0.15s;
        background-position: -93.334px 0;
      }

      &:nth-child(4) {
        background-position: 0 -46.667px;
        animation-delay: 0.2s;
      }

      &:nth-child(5) {
        background-position: -46.667px -46.667px;
        animation-delay: 0.25s;
      }

      &:nth-child(6) {
        background-position: -93.334px -46.667px;
        animation-delay: 0.3s;
      }

      &:nth-child(7) {
        background-position: 0 -93.334px;
        animation-delay: 0.35s;
      }

      &:nth-child(8) {
        background-position: -46.667px -93.334px;
        animation-delay: 0.4s;
      }

      &:nth-child(9) {
        background-position: -93.334px -93.334px;
        animation-delay: 0.45s;
      }
    }
  }

  @keyframes loading {
    50% {
      transform: translateZ(0.5em);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue